import { optionsMap } from 'pro-gallery-lib';
import { PRIVATE_CONTROLLERS } from './common/private-controllers';
export var settingsOptions = {
    settings: [
        optionsMap.behaviourParams.item.clickAction,
        optionsMap.behaviourParams.item.content.loader,
        {
            MEDIA_PERMISSION: [
                optionsMap.behaviourParams.gallery.blockContextMenu,
            ],
        }
    ],
    behaviors: {
        VIDEO: [
            optionsMap.behaviourParams.item.video.playTrigger,
            PRIVATE_CONTROLLERS.VIDEO.VOLUME,
            optionsMap.behaviourParams.item.video.speed,
            optionsMap.behaviourParams.item.video.loop,
            optionsMap.behaviourParams.item.video.enablePlayButton,
        ],
    },
    animation: [
        {
            id: 'hover',
            label: 'Native_ProGallery_Animations_Hover',
            options: [
                optionsMap.behaviourParams.item.content.hoverAnimation,
                optionsMap.behaviourParams.item.overlay.hoverAnimation,
            ],
        },
        {
            id: 'scroll',
            label: 'Native_ProGallery_Animations_Scroll',
            options: [
                optionsMap.behaviourParams.item.content.placementAnimation,
                optionsMap.behaviourParams.gallery.horizontal.slideAnimation,
                optionsMap.behaviourParams.gallery.scrollAnimation,
            ],
        },
    ],
};
//# sourceMappingURL=settingsOptions.js.map